export default __webpack_public_path__ + "static/teamPhoto8-48b22f8f0755d35d4190314ba516e8c2.png";